module.exports = __webpack_public_path__ + "img/terms.e57d81d3.svg";